// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FinalizeResumeV2 {
  max-width: 1184px;
  display: flex;
  gap: 24px;
  margin: 0 auto;
}

.FinalizeResumeV2_lock_profile_edit {
  width: 70%;
  margin: 0 auto;
}

@media screen and (max-width: 1024px) {
  .FinalizeResumeV2 {
    flex-direction: column;
    padding-right: 10px;
  }
}

.FinalizeResumeV2-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.FinalizeResumeV2-title > * {
  margin: 0;
}

.FinalizeResumeV2-leftcol {
  flex: 718;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 15px;
}

.FinalizeResumeV2-rightcol {
  flex: 442;
}



.FinalizeResumeV2-title h1 {
  letter-spacing: 0px;
  color: #212121;
  font-size: 28px;
  line-height: 37px;
  font-weight: 500;
}

.FinalizeResumeV2-p {
  font-size: 14px;
  line-height: 19px;
}

.FinalizeResumeV2-submit {
  max-width: 180px;
  background: #2E6EDF !important;
}

.TuringCollapse-header {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 7px 0;
}

.TuringCollapse-header .TuringCollapse-title {
  flex: 1;
}

.TuringCollapse-title {
  color: #212121;
  font-size: 16px;
  line-height: 26px;
}

.TuringCollapse-header .material-icons {
  color: #888888;
}

.TuringCollapse-headerright {
  color: #333333;
  font-size: 14px;
  line-height: 20px;
  margin-right: 4px;
  font-weight: 500;
}

.TuringCollapse {
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 8px;
}

.TuringCollapse>.ant-collapse-item {
  border-radius: 8px !important;
}

.TuringCollapse .ant-collapse-header {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

.TuringCollapse .ant-collapse-content,
.TuringCollapse .ant-collapse-content-box {
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

.TuringCollapse>.ant-collapse-item {
  background-color: #fff;
  -webkit-transition: all 300ms ease-in-out;
  -moz-transition: all 300ms ease-in-out;
  -ms-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
}

.TuringCollapse>.ant-collapse-item {
  background-color: #fff;
}

.TuringCollapse>.ant-collapse-item.ant-collapse-item-active {
  background-color: #f8f8f8;
}

.TuringCollapse .ant-collapse-content-box {
  background-color: #fff;
  padding-top: 15px !important;
}

.FinalizeResumeV2RequiredActions {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.FinalizeResumeV2RequiredActions.homev1 {
  position: fixed;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
}

@media screen and (max-width: 1024px) {
  .FinalizeResumeV2RequiredActions {
    position: relative  ;
  }
}

.FinalizeResumeV2RequiredActions .TuringCollapse-title {
  color: #212121;
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
}

.FinalizeResumeV2RequiredActions>*>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {
  background-color: #FFCF3F;
  border-radius: 6px;
  color: #fff;
  font-weight: 500;
}

.FinalizeResumeV2RequiredActions .color2>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {
  background-color: #56A8F7;
  border-radius: 6px;
}

.FinalizeResumeV2RequiredActions .color5>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {
  background-color: #005499;
  border-radius: 6px;
}

.FinalizeResumeV2RequiredActions>*>.ant-collapse-item.ant-collapse-item-active .TuringCollapse-title {
  color: #fff;
}

.FinalizeResumeV2RequiredActions .ant-collapse-header {
  margin-right: 7px;
  border-radius: 6px;
}

.FinalizeResumeV2RequiredActions .TuringCollapse-header {
  padding: 0;
}

.FinalizeResumeV2RequiredActions .ant-collapse-item {
  border-left: 7px solid #FFCF3F;
}

.FinalizeResumeV2RequiredActions .color2 .ant-collapse-item {
  border-left: 7px solid #56A8F7;
}

.FinalizeResumeV2RequiredActions .color1>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {
  background-color: #FFCF3F;
  border-radius: 6px;
}

.FinalizeResumeV2RequiredActions .color1 .ant-collapse-item {
  border-left: 7px solid #FFCF3F;
}

.FinalizeResumeV2RequiredActions .color3>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {
  background-color: #6ba6f1;
  border-radius: 6px;
}

.FinalizeResumeV2RequiredActions .color3 .ant-collapse-item {
  border-left: 7px solid #66CC80;
}

.FinalizeResumeV2RequiredActions .color4>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {
  background-color: #444444;
  border-radius: 6px;
}

.FinalizeResumeV2RequiredActions .color4 .ant-collapse-item {
  border-left: 7px solid #444444;
}

.FinalizeResumeV2RequiredActions .ant-collapse-item.ant-collapse-item-active {
  border-left: 7px solid #fff;
  padding-top: 7px;
}


.RequiredActions-sugg {
  background-color: #56A8F7;
  border-radius: 6px;
  min-height: 40px;
  display: flex;
  align-items: center;
  line-height: 14px;
  font-size: 14px;
  padding: 0 7px 0 15px;
  margin: 15px -7px 15px -15px;
  color: #fff;
}

.RequiredActionItem {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 2px;
}

.RequiredActionItem-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 100%;
}

.RequiredActionItem-show,
.RequiredActionItem-edit {
  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -ms-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
  overflow: hidden;
  display: flex;
  width: 100%;
}

.RequiredActionItemflex1 {
  flex: 1;
}

.RequiredActionItem-btn {
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f8f8;
  cursor: pointer;
}

.RequiredActionItem-edit {
  background-color: #f8f8f8;
}

.requiredActionsListnoicon .ant-collapse-content-box {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}

.RequiredActionItem-title {
  color: #212121;
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
}



.RequiredActionItem .material-icons {
  color: #FFCF3F;
}

.RequiredActionItem-info .material-icons {
  color: #005499;
  border-color: #005499;
  background-color: white;
}

.RequiredActionItem-assistant .material-icons {
  color: #56A8F7;
}

.RequiredActionItem-lightbulb .material-icons {
  color: #66CC80;
}

.Noactionrequired {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
}

/* .PersonalInformationForm .ant-form-item,
.PersonalInformationForm>*>* {
.parsedInfo-text {

} */

.PersonalInformationForm .ant-form-item, .PersonalInformationForm > * > * {
  margin: 0;
  color: #212121;
  font-size: 14px;
  line-height: 19px;
}


.PersonalInformationForm {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto auto auto;
  gap: 16px 16px;
  grid-auto-flow: row;
  grid-template-areas:
    "a a"
    "b b"
    "c d"
    "e e";
}

.PersonalInformationForm.new {
  grid-template-areas:
    "a a"
    "b b"
    "c c"
    "d d"
    "e e";
}

.a {
  grid-area: a;
}

.b {
  grid-area: b;
}

.c {
  grid-area: c;
}

.d {
  grid-area: d;
}

.e {
  grid-area: e;
}

.f {
  grid-area: f;
}

.profile-img-holder.new span {
  font-weight: 500;
  color: #2E6EDF;
}
.linkedin-input-cont {
  display: flex;
  flex-direction: column;
}
.linkedin-input-cont .linkedin-wrapper {
  display: flex;
  align-items: center;
}
.linkedin-input-cont .ant-col {
  width: 100%;
}
.linkedin-input-cont .ant-form-item-label {
  text-align: left;
}
.linkedin-input-cont input
{
  height: 40px;
  padding: 9px 12px 7px 36px !important;
  font-size: 14px;
}

.linkedin-input-cont svg {
  height: 18px;
  width: 18px;
}

.import-linkedin-profile-btn {
  display: flex;
  align-items: center;
  padding: 18px 16px 18px 12px;
  color: #2E6EDF;
  font-weight: 500;
  border: 1px solid #2E6EDF;
  background: #fff;
}

.FinalizeResumeV2FormBtns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin: 24px 0 16px 0;
}

.PersonalInformationForm .summary {
  min-height: 128px;
}

.WorkHistory-freelance {
  border-top: 1px solid #EEEEEE;
  border-bottom: 1px solid #EEEEEE;
  margin-left: -16px;
  margin-right: -16px;
  padding: 16px 16px 0 16px;
  margin-bottom: 16px;
}

.WorkHistory-freelance label {
  margin: 0;
}

.freelance_year_work_exp_input {
  width: 40px !important;
  height: 30px !important;
  padding: 10px 8px !important;
}

.freelance_year_work_exp_inputt::-webkit-outer-spin-button,
.freelance_year_work_exp_input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  width: 0;
  margin: 0;
}

/* Firefox */
.freelance_year_work_exp_input[type=number] {
  -moz-appearance: textfield;
}

.frmcheckbox {
  display: flex;
  align-items: center;
  gap: 10px;
}

.frmcheckbox .ant-form-item {
  margin: 0;
}

.frmcheckbox1 {
  display: flex;
  gap: 5px;
  align-items: center;
}

.frmcheckbox1 input {
  font-size: 12px;
  max-width: 40px;
  height: 30px;
  padding: 1px;
  text-align: center;
}

.PersonalInformationForm .ant-checkbox-wrapper {
  margin: 0;
  display: flex;
  align-items: center;
}

.TuringStepsFormv2 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.TuringStepsFormv2 .ant-steps-dot .ant-steps-item-content,
.TuringStepsFormv2 .ant-steps-dot.ant-steps-small .ant-steps-item-content {
  width: initial;
  overflow: visible;
  padding-left: 20px;
  padding-right: 20px;
}

.TuringStepsFormv2 .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot,
.TuringStepsFormv2 .ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot,
.TuringStepsFormv2 .ant-steps-item-process .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
  background-color: #fff;
  border: 3px solid #000;
  width: 15px;
  height: 15px;
}

.TuringStepsFormv2 .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
  border: 3px solid #ccc;
}

.TuringStepsFormv2 .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot,
.TuringStepsFormv2 .ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
  margin-left: -4px;
}

.TuringStepsFormv2 .ant-steps-item-process .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
  margin-left: -2px;
}

.TuringStepsFormv2 .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
  background-color: #CCCCCC;
}

.TuringStepsFormv2 .ant-steps-item-process>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-description,
.TuringStepsFormv2 .ant-steps-vertical>.ant-steps-item>.ant-steps-item-container>.ant-steps-item-tail::after {
  height: calc(100%);
}

.TuringStepsFormv2 .ant-steps-item-process>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-description,
.TuringStepsFormv2 .ant-steps-item-wait>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-description,
.TuringStepsFormv2 .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-description {
  color: #000;
}

.TuringStepsFormv2 .ant-steps-item-wait>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title,
.TuringStepsFormv2 .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title,
.TuringStepsFormv2 .ant-steps-item-title {
  font-weight: 500;
  color: #000;
}

.TuringStepsFormv2 .ant-steps-vertical .ant-steps-item-title {
  padding-right: 0;
}

.WorkHistoryItem-title {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 10px;
  cursor: pointer;
}

.WorkHistoryItem-title2 {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  gap: 10px;
  cursor: pointer;
  width: 50%;
}

.WorkHistoryItem-title3{
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  gap: 10px;
  cursor: pointer;
}

.WorkHistoryItem-title>.material-icons,
.WorkHistoryItem-title2>.material-icons,
.WorkHistoryItem-title3>.material-icons{
  cursor: pointer;
}

.WorkHistoryItem-company {
  flex: 1;
  color: #ccc;

}

.WorkHistoryItem-missing-information {
  background-color: #FBEEE6;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  padding: 5px;
  box-sizing: border-box;
  color: #750507;
}

.TuringStepsFormv2 .ant-steps-item-title {
  display: block;
}


.TuringStepsFormv2 .additembtn {
  color: #2E6EDF;
  cursor: pointer;
  font-size: 14px;
  line-height: 19px;
  margin: 2px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 500;
}

.TuringStepsFormv2 .ant-steps-item.ant-steps-item-wait {
  margin-top: 7px;
}

.TuringStepsFormv2 .ant-steps-vertical>.ant-steps-item.ant-steps-item-active>.ant-steps-item-container>.ant-steps-item-tail::after {
  height: calc(100% + 12px);
}


.WorkHistoryItem-form {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto auto;
  gap: 8px 8px;
  grid-auto-flow: row;
  grid-template-areas:
    "listErrors listErrors listErrors listErrors"
    "a a b b"
    "c d e f"
    "g g g g"
    "h h h h"
    "i i i i"
    "emptype emptype emptype emptype"
    "j j j j";
  padding-top: 16px;
}

.listErrors {
  grid-area: listErrors;
  display: flex;
  flex-direction: column;
  color: #F86567;
}
.a { grid-area: a; }
.b { grid-area: b; }
.c { grid-area: c; }
.d { grid-area: d; }
.e { grid-area: e; }
.f { grid-area: f; }
.g { grid-area: g; }
.h { grid-area: h; }
.emptype {
  grid-area: emptype;
  margin-bottom: 15px;
}

.emptype .ant-radio-group {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin: 15px 0;
}

.emptype .ant-radio-group>.ant-radio-wrapper {
  min-width: 109px;
  align-items: center;
}

.emptype .ant-radio-group>.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
  border-color: #000000;
}

.emptype .ant-radio-group>.ant-radio-wrapper .ant-radio-checked .ant-radio-inner::after {
  background-color: #000000;
}

.emptype .has-error {
  border: 1px dashed red;
  padding-left: 8px;
}

.WorkHistoryItem-form .WorkHistoryItem-date {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.WorkHistoryItem-form .ant-form-item {
  margin: 0;
}

.WorkHistoryItem-form .ant-select {
  width: 100%;
}

.TuringStepsFormv2 .ant-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.SideProjectsItem-form {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto auto;
  gap: 8px 8px;
  grid-auto-flow: row;
  grid-template-areas:
    "a a b b"
    "c d e f"
    "g g g g"
    "h h h h"
    "i i i i";
  padding-top: 16px;
}

.a {
  grid-area: a;
}

.b {
  grid-area: b;
}

.c {
  grid-area: c;
}

.d {
  grid-area: d;
}

.e {
  grid-area: e;
}

.f {
  grid-area: f;
}

.g {
  grid-area: g;
}

.h {
  grid-area: h;
}

.i {
  grid-area: i;
}

.j {
  grid-area: j;
}

.SideProjectsItem-form .SideProjectsItem-date {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.SideProjectsItem-form .ant-select {
  width: 100%;
}

.SideProjectsItem-form .ant-form-item {
  margin: 0;
}

.SideProjectsItem-title {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.SideProjectsItem-title>.material-icons {
  cursor: pointer;
}

.SideProjectsItem-project_name {
  flex: 1;
}


.SideProjectsItem-Projectdescription {
  min-height: 155px !important;
}


.EducationItem-form {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto;
  gap: 8px 8px;
  grid-auto-flow: row;
  grid-template-areas:
    "a a a a"
    "b b c c"
    "d e f g"
    "h h h h";
  padding-top: 16px;
}

.a {
  grid-area: a;
}

.b {
  grid-area: b;
}

.c {
  grid-area: c;
}

.d {
  grid-area: d;
}

.e {
  grid-area: e;
}

.f {
  grid-area: f;
}

.g {
  grid-area: g;
}

.h {
  grid-area: h;
}

.EducationItem-title {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.EducationItem-title>.material-icons {
  cursor: pointer;
}

.EducationItem-degree {
  font-size: 14px;
  line-height: 160%;
  padding-top: 2px;
}

.EducationItem-form .ant-form-item {
  margin: 0;
}

.EducationItem-form .ant-select {
  width: 100%;
}

.EducationItem-form .EducationItem-date {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.TuringStepsFormv2-title {
  color: #212121;
  font-size: 14px;
  line-height: 21px;
}

.cancel {
  background: #FFE6E6;
  width: 88px;
  color: #750507;
}

.cancelIcon {
  color: #750507;
  font-size: 17px;
}

.cloudcertificateinfo {
  background-color: #56A8F7 !important
}

.CloudCertitificationItem-needsInfoText {
  font-style: normal;
  font-weight: 400;
  padding: 5px 5px 0px 5px;
  font-size: 12px;
  line-height: 17px;
  color: #888888;
  letter-spacing: 0.0015em;
}

.PublicationsItem-title {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.PublicationsItem-title>.material-icons {
  cursor: pointer;
}

.PublicationsItem-degree {
  flex: 1;
}

.PublicationsItem-form .ant-form-item {
  margin: 0;
}

.PublicationsItem-form .ant-select {
  width: 100%;
}

.PublicationsItem-form .PublicationsItem-date {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.PublicationsItem-form {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: auto auto;
  gap: 8px 8px;
  grid-auto-flow: row;
  grid-template-areas:
    "a a"
    "b c";
  padding-top: 16px;
}

.a {
  grid-area: a;
}

.b {
  grid-area: b;
}

.c {
  grid-area: c;
}


.CloudCertitificationItem-form {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}
.CloudCertitificationItem-form-certificate-name {
  flex: 1;
  margin-right: 15px;
}

.CloudCertitificationItem-file {
  flex: 1;
  margin-right: 15px;
}

.CloudCertitificationItem-file .ant-upload-select {
  width: 100%;
}

.CloudCertitificationItem-form-child {
  flex: 1;
}

.CloudCertitificationItem-form-child-link{
  width:100%;
}

.borderless {
  border: none !important
}

.submit_btn {
  height: 42px !important;
  margin-top: 14px;
  width: 120px !important;
  background-color: #2E6EDF !important
}


.submitbtn_wrapper .ant-btn-primary:focus {
  background-color: #2E6EDF !important
}

.additional_info_seperator {
  width: 600px;
  height: 0px;
  margin-bottom: 24px;
  border-bottom: 1px solid #DDDDDD;
}

.CertificationsItem-title {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.CertificationsItem-title>.material-icons {
  cursor: pointer;
}

.CertificationsItem-name {
  flex: 1;
}

.CertificationsItem-form .ant-form-item {
  margin: 0;
}

.CertificationsItem-form .ant-select {
  width: 100%;
}

.CertificationsItem-form .CertificationsItem-date {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.CertificationsItem-form {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: auto;
  gap: 8px 8px;
  grid-auto-flow: row;
  grid-template-areas:
    "a b";
  padding-top: 16px;
}

.cloud-success-message {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 6px;

  background: #D8EBFD;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #063E75;
  margin-bottom: 15px;
  border-radius: 6px;
}

.a {
  grid-area: a;
}

.b {
  grid-area: b;
}

.ongoing_project {
  grid-area: ongoing_project;
  padding-top: 10px;
}


.WorkHistoryItemProjectItem-form {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto auto auto auto;
  gap: 8px 8px;
  grid-auto-flow: row;
  grid-template-areas:
    "listErrors listErrors listErrors listErrors"
    "tt tt tt tt"
    "a a b b"
    "c d e f"
    "ongoing_project ongoing_project ongoing_project ongoing_project"
    "g g g g"
    "outcome outcome outcome outcome"
    "h h h h"
    "i i i i"
  ;
  padding-top: 16px;
}

.outcome {
  grid-area: outcome;
}

.tt {
  grid-area: tt;
  color: #212121;
  font-size: 14px;
  line-height: 21px;
  margin: 10px 0;
  font-weight: 500;
  flex: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.WorkHistoryItemProjectItem-form .g textarea, .WorkHistoryItem-form .h textarea {
  min-height: 155px;
}

.WorkHistoryItemProjectItem-title,
.WorkHistoryItemProjectItem-title2,
.WorkHistoryItemProjectItem-title3 {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.addNewProjectItem {
  margin: 2px 0 !important;
  font-weight: 500;
}

.WorkHistoryItemProjects-titles {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.WorkHistoryItemProjects-title {
  color: #212121;
  font-size: 16px;
  line-height: 26px;
  font-weight: 500;
}

.WorkHistoryItemProjects-title span {
  margin-right: 10px;
}

.FinalizeResumeV2RequiredActionsparent .ant-collapse-item {
  background-color: #fff !important;
}

.AdditionalInformationForm-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #212121;
  font-size: 20px;
  line-height: 26px;
  font-weight: 500;
}

.FinalizeResumeV2 .ant-form-item-label,
.FinalizeResumeV2 .ant-collapse-content {
  overflow: visible;
}

.TuringCollapse-warning {
  padding: 5px;
  background-color: #FFCF3F;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  margin: -2px 0;
}

.TuringCollapse-warning>span {
  color: #fff !important;
  font-size: 20px !important;
  line-height: 20px !important;
}

/* .FinalizeResumeV2RequiredActions .ant-collapse-item {
  max-height: 85vh;
  overflow-y: auto;
} */

.FinalizeResumeV2RequiredActions .ant-collapse-item::-webkit-scrollbar,
.FinalizeResumeV2RequiredActions::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.FinalizeResumeV2RequiredActions .ant-collapse-item::-webkit-scrollbar-thumb,
.FinalizeResumeV2RequiredActions::-webkit-scrollbar-thumb {
  background: #B3AFB3;
  border-radius: 5px;
}

.FinalizeResumeV2RequiredActions .ant-collapse-item::-webkit-scrollbar-thumb:hover,
.FinalizeResumeV2RequiredActions::-webkit-scrollbar-thumb:hover {
  background: #666666;
}

.FinalizeResumeV2RequiredActions .ant-collapse-item::-webkit-scrollbar-track,
.FinalizeResumeV2RequiredActions::-webkit-scrollbar-track {
  background: #F0F0F0;
  border-radius: 4px;
  box-shadow: inset 0px 0px 0px 0px #F0F0F0;
}

.show-placeholder .ant-select-selection__placeholder {
  display: block !important;
}

.FinalizeResumeV2Sep {
  height: 30px;
}

.FinalizeResumeV2 .ant-steps {
  padding-left: 8px;
}

.addNewProjectItemcontainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.addNewProjectItemcontainer button {
  font-size: 12px;
  height: 27px;
  line-height: 15px;
}

.btnnotenoughexp {
  white-space: pre-wrap;
  margin-bottom: 15px;
  display: block;
  height: fit-content;
  padding: 10px;
}

.screenshots-error b, .profile-error {
  color: red;
}

.screenshots-error .ant-upload.ant-upload-select-picture-card {
  border-color: red;
}

.openStep>.ant-steps-item-container>.ant-steps-item-icon>.ant-steps-icon>.ant-steps-icon-dot {
  background-color: #000;
  border: 4px solid rgba(255, 255, 255, 0.7);
  width: 20px;
  height: 20px;
  margin-left: -6px;
  margin-top: -2px;
}

.step-custom-fill svg path {
  fill: #212121;
}

.TuringStepsFormv2 .ant-steps-item-content {
  padding-top: 2px;
}

.TuringStepsFormv2 .openStep>.ant-steps-item-content {
  padding-top: 5px;
}

.WorkHistoryItemProjects .ant-steps-item-title {
  margin-top: -8px;
}

.WorkHistoryItemProjects .openStep .ant-steps-item-title {
  margin-top: -10px;
}

.ant-steps-icon-dot {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
}

.WorkHistoryItemProjects .ant-steps-item-container>.ant-steps-item-icon>.ant-steps-icon>.ant-steps-icon-dot {
  background-color: #fff;
  border: 3px solid #000;
  width: 12px;
  height: 12px;
  margin-left: -2px;
  margin-top: 2px;
}

.WorkHistoryItemProjects .openStep .ant-steps-item-container>.ant-steps-item-icon>.ant-steps-icon>.ant-steps-icon-dot {
  background-color: #000;
  border: 3px solid rgba(255, 255, 255, 0.7);
  width: 12px;
  height: 12px;
  margin-left: -2px;
}

.WorkHistoryItemProjectItem-title, .WorkHistoryItemProjectItem-title2 {
  border-bottom: 1px solid #EEEEEE;
}

.WorkHistoryItemProjects .ant-steps-vertical .ant-steps-item-content {
  min-height: 40px;
}

.WorkHistoryItemProjects .WorkHistoryItemProjectsaddnew .ant-steps-item-title {
  margin-top: 0;
}

.WorkHistoryItemProjectsaddnew.ant-steps-item-wait .ant-steps-icon-dot {
  border-color: #cccccc !important;
}

.SkillsSelector li.ant-select-selection__choice {
  margin-bottom: 20px;
  overflow: visible;
  min-width: 109px;
  border-radius: 12px;
  font-size: 12px;
  padding-left: 0;
}

.SkillsSelector-note {
  position: absolute;
  left: 0;
  top: 22px;
  font-size: 10px;
  padding-left: 5px;
}

.SkillsSelector-Notmentioned {
  color: #F86567;
}

.SkillsSelector li.ant-select-selection__choice .ant-select-selection__choice__remove {
  background: #d2d2d2;
  width: 20px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  margin-right: -3px;
}

.RequiredActionItem-close {
  transform: scaleY(0);
  height: 0;
}

.RequiredActionItem-open {
  transform: scaleY(1);
  height: auto;
}

.RequiredActionItem-btn>.material-icons {
  color: #888888;
}

.requiredActionsListnoicon .RequiredActionItem {
  border-top: 1px solid #ddd;
}

.requiredActionsListnoicon .RequiredActionItem:last-child {
  border-bottom: 1px solid #ddd;
}

.requiredActionsListnoicon .RequiredActionItem:first-child {
  border-top: 1px solid transparent;
}

.requiredActionsListnoicon .RequiredActionItemflex1 {
  padding-left: 16px;
  margin: 10px 0;
}

.requiredActionsListnoicon .RequiredActionItem {
  margin-bottom: 0;
}

.requiredActionsListnoicon .ant-collapse-content-active {
  margin-left: -7px;
}

.requiredActionsListnoicon .ant-collapse-item-active {
  overflow: visible;
}

.skillMentionsItem {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
}

.skillMentionsItem-title {
  overflow: hidden;
  text-overflow: ellipsis;
}

.skillMentionsItem-editlink {
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}

.focusAnimation {
  border: 2px solid #ffcf3f !important;
  position: relative;
}

.roleatthecompany {
  margin: -20px 0 20px 0;
}

.roleatthecompany textarea {
  min-height: 155px;
}

.Delete-work-experience-item-p {
  margin-top: 20px;
}

.Delete-work-experience-item>h1 {
  color: #F86567;
  font-size: 20px;
  line-height: 32px;
}

.Delete-work-experience-item-details {
  padding: 5px 10px;
  border-left: 5px solid #F86567;
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 14px;
  line-height: 19px;
}

.Delete-work-experience-item-details>span>*+* {
  margin-left: 5px;
}

.delete-item-modal {
  top: 50% !important;
  margin-top: -117px !important;
}

.font-medium {
  font-weight: 500;
}

.color-aaa {
  color: #AAAAAA;
}

/* Peter Adeoye: New Resume Parser Improvement CSS */

.upload-new-resume .ant-card-body {
  padding: 18px !important;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0.15px;
  color: #212121;
}

.upload-new-resume span {
  margin-left: 12px;
}

.upload-new-resume a {
  font-weight: 500;
  color: #2E6EDF !important;
}

.upload-resume-warning-modal .ant-modal-close-x {
  display: none
}

.upload-resume-warning-card {
  margin-bottom: 8px;
  cursor: pointer;
  border: 1px solid #DDDDDD;
  border-radius: 6px;
}
.upload-resume-warning-card .ant-card-body {
  padding: 16px !important;
}

.resume-upload-warning-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 150%;
  color: #212121;
  margin-bottom: 16px;
}

.upload-resume-warning-modal .upload-resume-cancel-btn {
  color: #666666;
  margin-top: 16px;
}

.upload-resume-warning-modal .ant-modal-content {
  background: #FFFFFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}

.upload-resume-warning-card__title {
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  color: #000000;
}

.upload-resume-max-size {
  margin-top: 8px;
  color: #888888;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
}

.upload-resume__title {
  font-weight: 500;
  font-size: 17px;
  line-height: 23px;
  letter-spacing: 0.15px;
  color: #212121;
  margin-bottom: 16px;
}

.resume-upload-dragger-text {
  margin-left: 16px;
  text-align: left;
  color: #2E6EDF;
  line-height: 160%;
  letter-spacing: 0.15px;
  cursor: pointer;
}

.resume-upload-dragger-text__bigtext {
  font-weight: 500;
  font-size: 16px;
}

.resume-upload-dragger-text__smalltext {
  font-size: 14px;
}

.upload-btn-row .ant-btn-primary {
  background: #2E6EDF;
  border-radius: 6px;
}

.resume-upload-dragger .ant-upload-drag {
  width: 546px;
  height: 140px;
}

.replace-selected-resume svg {
  width: 20px !important;
  height: 13.33px !important;
}

.selected-resume-row {
  margin-left: 16px;
  margin-right: 16px;
  width: 500px;
}

.resume-upload-dragger .ant-upload-list {
  display: none;
}

.selected-resume-file {
  display: flex;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: #888888;
  width: 70%;
  text-align: left;
  align-items: center;
}

.replace-selected-resume .ant-btn {
  color: #2E6EDF !important;
}

.selected-resume-file span {
  margin-left: 11.33px;
  width: 90%;
}

.delete-existing-info-warning__header {
  margin-bottom: 8px;
}

.delete-existing-info-warning__header svg {
  width: 19.06px !important;
  height: 17.01px !important;
}

.delete-existing-info-warning__header span {
  margin-left: 10.47px;
  font-weight: 500;
  font-size: 20px;
  line-height: 27px;
  color: #F86567;
}

.delete-existing-info-warning__text {
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #212121;
}

.delete-existing-info-warning__buttons {
  margin-bottom: -8px !important;
}

.delete-existing-info-warning__buttons .ant-btn {
  height: 40px !important
}

.delete-existing-info-warning__buttons .ant-btn-danger {
  width: 170px !important
}

.resume-uploaded-alert .ant-alert {
  min-height: 58px !important;
  height: auto;
}

.resume-uploaded-alert .ant-alert-success {
  background: #E0F5E6;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}

.resume-uploaded-alert .ant-icon-close {
  color: #C4C4C4 !important;
}

.resume-uploaded-alert svg {
  width: 16px !important;
  height: 16px !important;
}

.resume-uploaded-alert .ant-alert-description {
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0.15px;
  color: #1F5C2E;
}

.resume-uploaded-alert .anticon-check-circle > svg {
  width: 20px !important;
  height: 20px !important;
  color: #1F5C2E;
}
.resume-warning-alert.ant-alert {
  height: fit-content;
  margin: auto;
  background: #FFE6E6;
  border-color: #FFE6E6;
  border-radius: 6px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.resume-warning-alert svg {
  width: 15.89px;
  height: 14.17px;
}

.resume-warning-alert .anticon {
  margin-top: -4px;
}

.resume-warning-alert .ant-alert-message {
  font-size: 14px;
  line-height: 20px;
  color: #750507;
}

.resume-warning-alert > .anticon > svg > g > path {
  fill: #750507 !important
}

.custom-edit {
  color: #2E6EDF !important;
}

.preview-resume-btn {
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 12px;
}

.view-uploaded-resume-btn {
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 12px;
}

.view-uploaded-resume-btn:hover {
  border: 1px solid #2E6EDF;
  background: #fff;
}

.custom-warning-align {
  flex: 1;
  text-align: right;
}
.see-more-0r-less{
  color: #2E6EDF;
  cursor: pointer;
  font-weight: 500;
}

.resume-text {
  font-weight: 100;
  color: #444;
}

.parsedInfo.TuringCollapse .ant-collapse-content-box {
  padding: 14px 16px 22px 16px !important;
}

.parsedInfo.requiredActionsListnoicon .RequiredActionItemflex1 {
  padding: 0;
  margin: 16px 0;
}

.parsedInfo .view-uploaded-resume-btn {
  margin-right: 0;
  margin-bottom: 14px;
}

.parsedInfo .parsedInfo-text .text {
  margin-bottom: 0;
}

.requiredActionsListnoicon.hide {
  display: none;
}

.WorkHistoryItem-form .anticon-close-circle {
  display: none;
}

.WorkHistory-flex {
  display: flex;
  cursor: pointer;
}

.WorkHistory-flex .resume-warning-alert,
.WorkHistoryItem-title2 .resume-warning-alert,
.WorkHistoryProject-flex .resume-warning-alert{
  font-weight: normal;
}

.WorkHistoryProject-flex{
  margin-top: 7px;
  display: flex;
  cursor: pointer;
}

.tiny-margin-left {
  margin-left: 10px;
  top: 3px;
}
.ProjectName-flex {
  display: flex;
}

.deleteAndIcon {
  position: absolute;
  right: 0;
  display: flex;
  align-self: center;
  justify-content: space-between;
  margin-left: 10px;
}

.WorkHistoryItem-missing-information-left-margin,
.WorkHistoryItem-missing-information-left-margin2,
.WorkHistoryItem-missing-information-left-margin3{
  margin-left: 10px;
  align-self: center;
}


.deleteIconMarginLeft {
  margin-right: 10px;
}

.openClose {
  color: #ccc;
}

.projectTitle-open {
  margin-bottom: 5px;
}



@media screen and (max-width: 1220px) {
  .WorkHistoryItem-title3 {
    margin-top: 5px;
    margin-bottom: 10px;
  }

  .WorkHistory-flex .WorkHistoryItem-missing-information-left-margin3 {
    position: absolute;
    left: 0;
    bottom: -20px;
    margin-left: 0px;
    width: 200px;
  }
}

@media screen and (max-width: 1370px) {
  .WorkHistoryProject-flex .WorkHistoryItem-missing-information-left-margin3 {
    position: absolute;
    left: 0;
    bottom: -20px;
    margin-left: 0px;
    width: 200px;
  }
}

@media screen and (max-width: 1500px) {
  .WorkHistory-flex, .WorkHistoryProject-flex{
    position: relative;
    margin-bottom: 20px;
  }

  .WorkHistoryItem-title2 {
    margin-top: 5px;
    margin-bottom: 10px;
    width: 90%;
  }

  .ProjectName-flex {
    position: relative;
  }

  .WorkHistory-flex .WorkHistoryItem-missing-information-left-margin {
    position: absolute;
    left: 0;
    bottom: -20px;
    margin-left: 0px;
    width: 200px;
  }

  .WorkHistoryProject-flex .WorkHistoryItem-missing-information-left-margin {
    position: absolute;
    left: 0;
    bottom: -22px;
    margin-left: 0px;
    width: 200px;
  }

  .WorkHistoryItemProjectItem-title2, .WorkHistoryItemProjectItem-title3{
    width: 80%;
  }
}

@media screen and (min-width: 1501px) {
  .WorkHistoryItemProjectItem-title3 {
    width: 50%;
  }

  .WorkHistoryItemProjectItem-title2 {
    width: 50%;
  }
}



`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/FinalizeResume/FinalizeResumeV2.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;;AAGA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;;;AAIA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;;EAEE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;GAIG;;AAEH;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,uCAAuC;EACvC,cAAc;EACd,mBAAmB;EACnB;;;;SAIO;AACT;;AAEA;EACE;;;;;SAKO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;EACxB,QAAQ;EACR,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,WAAW;;AAEb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,sCAAsC;EACtC,iDAAiD;EACjD,YAAY;EACZ,mBAAmB;EACnB;;;;;;;;aAQW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA,KAAK,YAAY,EAAE;AACnB,KAAK,YAAY,EAAE;AACnB,KAAK,YAAY,EAAE;AACnB,KAAK,YAAY,EAAE;AACnB,KAAK,YAAY,EAAE;AACnB,KAAK,YAAY,EAAE;AACnB,KAAK,YAAY,EAAE;AACnB,KAAK,YAAY,EAAE;AACnB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,iDAAiD;EACjD,YAAY;EACZ,mBAAmB;EACnB;;;;;aAKW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;;AAGA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,aAAa;EACb,sCAAsC;EACtC,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB;;;;aAIW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB;;SAEO;EACP,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;;AAGA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB;SACO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;;EAEhB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,sCAAsC;EACtC,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;EACnB;;;;;;;;;;EAUA;EACA,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;;GAGG;;AAEH;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oDAAoD;;AAEpD;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".FinalizeResumeV2 {\n  max-width: 1184px;\n  display: flex;\n  gap: 24px;\n  margin: 0 auto;\n}\n\n.FinalizeResumeV2_lock_profile_edit {\n  width: 70%;\n  margin: 0 auto;\n}\n\n@media screen and (max-width: 1024px) {\n  .FinalizeResumeV2 {\n    flex-direction: column;\n    padding-right: 10px;\n  }\n}\n\n.FinalizeResumeV2-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n\n.FinalizeResumeV2-title > * {\n  margin: 0;\n}\n\n.FinalizeResumeV2-leftcol {\n  flex: 718;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 0 15px;\n}\n\n.FinalizeResumeV2-rightcol {\n  flex: 442;\n}\n\n\n\n.FinalizeResumeV2-title h1 {\n  letter-spacing: 0px;\n  color: #212121;\n  font-size: 28px;\n  line-height: 37px;\n  font-weight: 500;\n}\n\n.FinalizeResumeV2-p {\n  font-size: 14px;\n  line-height: 19px;\n}\n\n.FinalizeResumeV2-submit {\n  max-width: 180px;\n  background: #2E6EDF !important;\n}\n\n.TuringCollapse-header {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  padding: 7px 0;\n}\n\n.TuringCollapse-header .TuringCollapse-title {\n  flex: 1;\n}\n\n.TuringCollapse-title {\n  color: #212121;\n  font-size: 16px;\n  line-height: 26px;\n}\n\n.TuringCollapse-header .material-icons {\n  color: #888888;\n}\n\n.TuringCollapse-headerright {\n  color: #333333;\n  font-size: 14px;\n  line-height: 20px;\n  margin-right: 4px;\n  font-weight: 500;\n}\n\n.TuringCollapse {\n  box-shadow: 0px 2px 4px #00000029;\n  border-radius: 8px;\n}\n\n.TuringCollapse>.ant-collapse-item {\n  border-radius: 8px !important;\n}\n\n.TuringCollapse .ant-collapse-header {\n  border-top-left-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n\n.TuringCollapse .ant-collapse-content,\n.TuringCollapse .ant-collapse-content-box {\n  border-bottom-left-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n}\n\n.TuringCollapse>.ant-collapse-item {\n  background-color: #fff;\n  -webkit-transition: all 300ms ease-in-out;\n  -moz-transition: all 300ms ease-in-out;\n  -ms-transition: all 300ms ease-in-out;\n  -o-transition: all 300ms ease-in-out;\n  transition: all 300ms ease-in-out;\n}\n\n.TuringCollapse>.ant-collapse-item {\n  background-color: #fff;\n}\n\n.TuringCollapse>.ant-collapse-item.ant-collapse-item-active {\n  background-color: #f8f8f8;\n}\n\n.TuringCollapse .ant-collapse-content-box {\n  background-color: #fff;\n  padding-top: 15px !important;\n}\n\n.FinalizeResumeV2RequiredActions {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.FinalizeResumeV2RequiredActions.homev1 {\n  position: fixed;\n  max-height: calc(100vh - 100px);\n  overflow-y: auto;\n}\n\n@media screen and (max-width: 1024px) {\n  .FinalizeResumeV2RequiredActions {\n    position: relative  ;\n  }\n}\n\n.FinalizeResumeV2RequiredActions .TuringCollapse-title {\n  color: #212121;\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 500;\n}\n\n.FinalizeResumeV2RequiredActions>*>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {\n  background-color: #FFCF3F;\n  border-radius: 6px;\n  color: #fff;\n  font-weight: 500;\n}\n\n.FinalizeResumeV2RequiredActions .color2>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {\n  background-color: #56A8F7;\n  border-radius: 6px;\n}\n\n.FinalizeResumeV2RequiredActions .color5>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {\n  background-color: #005499;\n  border-radius: 6px;\n}\n\n.FinalizeResumeV2RequiredActions>*>.ant-collapse-item.ant-collapse-item-active .TuringCollapse-title {\n  color: #fff;\n}\n\n.FinalizeResumeV2RequiredActions .ant-collapse-header {\n  margin-right: 7px;\n  border-radius: 6px;\n}\n\n.FinalizeResumeV2RequiredActions .TuringCollapse-header {\n  padding: 0;\n}\n\n.FinalizeResumeV2RequiredActions .ant-collapse-item {\n  border-left: 7px solid #FFCF3F;\n}\n\n.FinalizeResumeV2RequiredActions .color2 .ant-collapse-item {\n  border-left: 7px solid #56A8F7;\n}\n\n.FinalizeResumeV2RequiredActions .color1>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {\n  background-color: #FFCF3F;\n  border-radius: 6px;\n}\n\n.FinalizeResumeV2RequiredActions .color1 .ant-collapse-item {\n  border-left: 7px solid #FFCF3F;\n}\n\n.FinalizeResumeV2RequiredActions .color3>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {\n  background-color: #6ba6f1;\n  border-radius: 6px;\n}\n\n.FinalizeResumeV2RequiredActions .color3 .ant-collapse-item {\n  border-left: 7px solid #66CC80;\n}\n\n.FinalizeResumeV2RequiredActions .color4>.ant-collapse-item.ant-collapse-item-active .ant-collapse-header {\n  background-color: #444444;\n  border-radius: 6px;\n}\n\n.FinalizeResumeV2RequiredActions .color4 .ant-collapse-item {\n  border-left: 7px solid #444444;\n}\n\n.FinalizeResumeV2RequiredActions .ant-collapse-item.ant-collapse-item-active {\n  border-left: 7px solid #fff;\n  padding-top: 7px;\n}\n\n\n.RequiredActions-sugg {\n  background-color: #56A8F7;\n  border-radius: 6px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  line-height: 14px;\n  font-size: 14px;\n  padding: 0 7px 0 15px;\n  margin: 15px -7px 15px -15px;\n  color: #fff;\n}\n\n.RequiredActionItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 2px;\n}\n\n.RequiredActionItem-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  max-width: 100%;\n}\n\n.RequiredActionItem-show,\n.RequiredActionItem-edit {\n  -webkit-transition: all 200ms ease-in-out;\n  -moz-transition: all 200ms ease-in-out;\n  -ms-transition: all 200ms ease-in-out;\n  -o-transition: all 200ms ease-in-out;\n  transition: all 200ms ease-in-out;\n  overflow: hidden;\n  display: flex;\n  width: 100%;\n}\n\n.RequiredActionItemflex1 {\n  flex: 1;\n}\n\n.RequiredActionItem-btn {\n  width: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f8f8;\n  cursor: pointer;\n}\n\n.RequiredActionItem-edit {\n  background-color: #f8f8f8;\n}\n\n.requiredActionsListnoicon .ant-collapse-content-box {\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 0;\n}\n\n.RequiredActionItem-title {\n  color: #212121;\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 500;\n}\n\n\n\n.RequiredActionItem .material-icons {\n  color: #FFCF3F;\n}\n\n.RequiredActionItem-info .material-icons {\n  color: #005499;\n  border-color: #005499;\n  background-color: white;\n}\n\n.RequiredActionItem-assistant .material-icons {\n  color: #56A8F7;\n}\n\n.RequiredActionItem-lightbulb .material-icons {\n  color: #66CC80;\n}\n\n.Noactionrequired {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100px;\n}\n\n/* .PersonalInformationForm .ant-form-item,\n.PersonalInformationForm>*>* {\n.parsedInfo-text {\n\n} */\n\n.PersonalInformationForm .ant-form-item, .PersonalInformationForm > * > * {\n  margin: 0;\n  color: #212121;\n  font-size: 14px;\n  line-height: 19px;\n}\n\n\n.PersonalInformationForm {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto auto auto auto;\n  gap: 16px 16px;\n  grid-auto-flow: row;\n  grid-template-areas:\n    \"a a\"\n    \"b b\"\n    \"c d\"\n    \"e e\";\n}\n\n.PersonalInformationForm.new {\n  grid-template-areas:\n    \"a a\"\n    \"b b\"\n    \"c c\"\n    \"d d\"\n    \"e e\";\n}\n\n.a {\n  grid-area: a;\n}\n\n.b {\n  grid-area: b;\n}\n\n.c {\n  grid-area: c;\n}\n\n.d {\n  grid-area: d;\n}\n\n.e {\n  grid-area: e;\n}\n\n.f {\n  grid-area: f;\n}\n\n.profile-img-holder.new span {\n  font-weight: 500;\n  color: #2E6EDF;\n}\n.linkedin-input-cont {\n  display: flex;\n  flex-direction: column;\n}\n.linkedin-input-cont .linkedin-wrapper {\n  display: flex;\n  align-items: center;\n}\n.linkedin-input-cont .ant-col {\n  width: 100%;\n}\n.linkedin-input-cont .ant-form-item-label {\n  text-align: left;\n}\n.linkedin-input-cont input\n{\n  height: 40px;\n  padding: 9px 12px 7px 36px !important;\n  font-size: 14px;\n}\n\n.linkedin-input-cont svg {\n  height: 18px;\n  width: 18px;\n}\n\n.import-linkedin-profile-btn {\n  display: flex;\n  align-items: center;\n  padding: 18px 16px 18px 12px;\n  color: #2E6EDF;\n  font-weight: 500;\n  border: 1px solid #2E6EDF;\n  background: #fff;\n}\n\n.FinalizeResumeV2FormBtns {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  margin: 24px 0 16px 0;\n}\n\n.PersonalInformationForm .summary {\n  min-height: 128px;\n}\n\n.WorkHistory-freelance {\n  border-top: 1px solid #EEEEEE;\n  border-bottom: 1px solid #EEEEEE;\n  margin-left: -16px;\n  margin-right: -16px;\n  padding: 16px 16px 0 16px;\n  margin-bottom: 16px;\n}\n\n.WorkHistory-freelance label {\n  margin: 0;\n}\n\n.freelance_year_work_exp_input {\n  width: 40px !important;\n  height: 30px !important;\n  padding: 10px 8px !important;\n}\n\n.freelance_year_work_exp_inputt::-webkit-outer-spin-button,\n.freelance_year_work_exp_input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  width: 0;\n  margin: 0;\n}\n\n/* Firefox */\n.freelance_year_work_exp_input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.frmcheckbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.frmcheckbox .ant-form-item {\n  margin: 0;\n}\n\n.frmcheckbox1 {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n\n.frmcheckbox1 input {\n  font-size: 12px;\n  max-width: 40px;\n  height: 30px;\n  padding: 1px;\n  text-align: center;\n}\n\n.PersonalInformationForm .ant-checkbox-wrapper {\n  margin: 0;\n  display: flex;\n  align-items: center;\n}\n\n.TuringStepsFormv2 {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.TuringStepsFormv2 .ant-steps-dot .ant-steps-item-content,\n.TuringStepsFormv2 .ant-steps-dot.ant-steps-small .ant-steps-item-content {\n  width: initial;\n  overflow: visible;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.TuringStepsFormv2 .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot,\n.TuringStepsFormv2 .ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot,\n.TuringStepsFormv2 .ant-steps-item-process .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {\n  background-color: #fff;\n  border: 3px solid #000;\n  width: 15px;\n  height: 15px;\n}\n\n.TuringStepsFormv2 .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {\n  border: 3px solid #ccc;\n}\n\n.TuringStepsFormv2 .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot,\n.TuringStepsFormv2 .ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {\n  margin-left: -4px;\n}\n\n.TuringStepsFormv2 .ant-steps-item-process .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {\n  margin-left: -2px;\n}\n\n.TuringStepsFormv2 .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {\n  background-color: #CCCCCC;\n}\n\n.TuringStepsFormv2 .ant-steps-item-process>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-description,\n.TuringStepsFormv2 .ant-steps-vertical>.ant-steps-item>.ant-steps-item-container>.ant-steps-item-tail::after {\n  height: calc(100%);\n}\n\n.TuringStepsFormv2 .ant-steps-item-process>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-description,\n.TuringStepsFormv2 .ant-steps-item-wait>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-description,\n.TuringStepsFormv2 .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-description {\n  color: #000;\n}\n\n.TuringStepsFormv2 .ant-steps-item-wait>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title,\n.TuringStepsFormv2 .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title,\n.TuringStepsFormv2 .ant-steps-item-title {\n  font-weight: 500;\n  color: #000;\n}\n\n.TuringStepsFormv2 .ant-steps-vertical .ant-steps-item-title {\n  padding-right: 0;\n}\n\n.WorkHistoryItem-title {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.WorkHistoryItem-title2 {\n  display: flex;\n  align-items: center;\n  margin-bottom: 3px;\n  gap: 10px;\n  cursor: pointer;\n  width: 50%;\n}\n\n.WorkHistoryItem-title3{\n  display: flex;\n  align-items: center;\n  margin-bottom: 3px;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.WorkHistoryItem-title>.material-icons,\n.WorkHistoryItem-title2>.material-icons,\n.WorkHistoryItem-title3>.material-icons{\n  cursor: pointer;\n}\n\n.WorkHistoryItem-company {\n  flex: 1;\n  color: #ccc;\n\n}\n\n.WorkHistoryItem-missing-information {\n  background-color: #FBEEE6;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  padding: 5px;\n  box-sizing: border-box;\n  color: #750507;\n}\n\n.TuringStepsFormv2 .ant-steps-item-title {\n  display: block;\n}\n\n\n.TuringStepsFormv2 .additembtn {\n  color: #2E6EDF;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 19px;\n  margin: 2px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-weight: 500;\n}\n\n.TuringStepsFormv2 .ant-steps-item.ant-steps-item-wait {\n  margin-top: 7px;\n}\n\n.TuringStepsFormv2 .ant-steps-vertical>.ant-steps-item.ant-steps-item-active>.ant-steps-item-container>.ant-steps-item-tail::after {\n  height: calc(100% + 12px);\n}\n\n\n.WorkHistoryItem-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-template-rows: auto auto auto auto auto auto;\n  gap: 8px 8px;\n  grid-auto-flow: row;\n  grid-template-areas:\n    \"listErrors listErrors listErrors listErrors\"\n    \"a a b b\"\n    \"c d e f\"\n    \"g g g g\"\n    \"h h h h\"\n    \"i i i i\"\n    \"emptype emptype emptype emptype\"\n    \"j j j j\";\n  padding-top: 16px;\n}\n\n.listErrors {\n  grid-area: listErrors;\n  display: flex;\n  flex-direction: column;\n  color: #F86567;\n}\n.a { grid-area: a; }\n.b { grid-area: b; }\n.c { grid-area: c; }\n.d { grid-area: d; }\n.e { grid-area: e; }\n.f { grid-area: f; }\n.g { grid-area: g; }\n.h { grid-area: h; }\n.emptype {\n  grid-area: emptype;\n  margin-bottom: 15px;\n}\n\n.emptype .ant-radio-group {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin: 15px 0;\n}\n\n.emptype .ant-radio-group>.ant-radio-wrapper {\n  min-width: 109px;\n  align-items: center;\n}\n\n.emptype .ant-radio-group>.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {\n  border-color: #000000;\n}\n\n.emptype .ant-radio-group>.ant-radio-wrapper .ant-radio-checked .ant-radio-inner::after {\n  background-color: #000000;\n}\n\n.emptype .has-error {\n  border: 1px dashed red;\n  padding-left: 8px;\n}\n\n.WorkHistoryItem-form .WorkHistoryItem-date {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.WorkHistoryItem-form .ant-form-item {\n  margin: 0;\n}\n\n.WorkHistoryItem-form .ant-select {\n  width: 100%;\n}\n\n.TuringStepsFormv2 .ant-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.SideProjectsItem-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-template-rows: auto auto auto auto auto auto;\n  gap: 8px 8px;\n  grid-auto-flow: row;\n  grid-template-areas:\n    \"a a b b\"\n    \"c d e f\"\n    \"g g g g\"\n    \"h h h h\"\n    \"i i i i\";\n  padding-top: 16px;\n}\n\n.a {\n  grid-area: a;\n}\n\n.b {\n  grid-area: b;\n}\n\n.c {\n  grid-area: c;\n}\n\n.d {\n  grid-area: d;\n}\n\n.e {\n  grid-area: e;\n}\n\n.f {\n  grid-area: f;\n}\n\n.g {\n  grid-area: g;\n}\n\n.h {\n  grid-area: h;\n}\n\n.i {\n  grid-area: i;\n}\n\n.j {\n  grid-area: j;\n}\n\n.SideProjectsItem-form .SideProjectsItem-date {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.SideProjectsItem-form .ant-select {\n  width: 100%;\n}\n\n.SideProjectsItem-form .ant-form-item {\n  margin: 0;\n}\n\n.SideProjectsItem-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.SideProjectsItem-title>.material-icons {\n  cursor: pointer;\n}\n\n.SideProjectsItem-project_name {\n  flex: 1;\n}\n\n\n.SideProjectsItem-Projectdescription {\n  min-height: 155px !important;\n}\n\n\n.EducationItem-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-template-rows: auto auto auto auto;\n  gap: 8px 8px;\n  grid-auto-flow: row;\n  grid-template-areas:\n    \"a a a a\"\n    \"b b c c\"\n    \"d e f g\"\n    \"h h h h\";\n  padding-top: 16px;\n}\n\n.a {\n  grid-area: a;\n}\n\n.b {\n  grid-area: b;\n}\n\n.c {\n  grid-area: c;\n}\n\n.d {\n  grid-area: d;\n}\n\n.e {\n  grid-area: e;\n}\n\n.f {\n  grid-area: f;\n}\n\n.g {\n  grid-area: g;\n}\n\n.h {\n  grid-area: h;\n}\n\n.EducationItem-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.EducationItem-title>.material-icons {\n  cursor: pointer;\n}\n\n.EducationItem-degree {\n  font-size: 14px;\n  line-height: 160%;\n  padding-top: 2px;\n}\n\n.EducationItem-form .ant-form-item {\n  margin: 0;\n}\n\n.EducationItem-form .ant-select {\n  width: 100%;\n}\n\n.EducationItem-form .EducationItem-date {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.TuringStepsFormv2-title {\n  color: #212121;\n  font-size: 14px;\n  line-height: 21px;\n}\n\n.cancel {\n  background: #FFE6E6;\n  width: 88px;\n  color: #750507;\n}\n\n.cancelIcon {\n  color: #750507;\n  font-size: 17px;\n}\n\n.cloudcertificateinfo {\n  background-color: #56A8F7 !important\n}\n\n.CloudCertitificationItem-needsInfoText {\n  font-style: normal;\n  font-weight: 400;\n  padding: 5px 5px 0px 5px;\n  font-size: 12px;\n  line-height: 17px;\n  color: #888888;\n  letter-spacing: 0.0015em;\n}\n\n.PublicationsItem-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.PublicationsItem-title>.material-icons {\n  cursor: pointer;\n}\n\n.PublicationsItem-degree {\n  flex: 1;\n}\n\n.PublicationsItem-form .ant-form-item {\n  margin: 0;\n}\n\n.PublicationsItem-form .ant-select {\n  width: 100%;\n}\n\n.PublicationsItem-form .PublicationsItem-date {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.PublicationsItem-form {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  grid-template-rows: auto auto;\n  gap: 8px 8px;\n  grid-auto-flow: row;\n  grid-template-areas:\n    \"a a\"\n    \"b c\";\n  padding-top: 16px;\n}\n\n.a {\n  grid-area: a;\n}\n\n.b {\n  grid-area: b;\n}\n\n.c {\n  grid-area: c;\n}\n\n\n.CloudCertitificationItem-form {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-between;\n}\n.CloudCertitificationItem-form-certificate-name {\n  flex: 1;\n  margin-right: 15px;\n}\n\n.CloudCertitificationItem-file {\n  flex: 1;\n  margin-right: 15px;\n}\n\n.CloudCertitificationItem-file .ant-upload-select {\n  width: 100%;\n}\n\n.CloudCertitificationItem-form-child {\n  flex: 1;\n}\n\n.CloudCertitificationItem-form-child-link{\n  width:100%;\n}\n\n.borderless {\n  border: none !important\n}\n\n.submit_btn {\n  height: 42px !important;\n  margin-top: 14px;\n  width: 120px !important;\n  background-color: #2E6EDF !important\n}\n\n\n.submitbtn_wrapper .ant-btn-primary:focus {\n  background-color: #2E6EDF !important\n}\n\n.additional_info_seperator {\n  width: 600px;\n  height: 0px;\n  margin-bottom: 24px;\n  border-bottom: 1px solid #DDDDDD;\n}\n\n.CertificationsItem-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.CertificationsItem-title>.material-icons {\n  cursor: pointer;\n}\n\n.CertificationsItem-name {\n  flex: 1;\n}\n\n.CertificationsItem-form .ant-form-item {\n  margin: 0;\n}\n\n.CertificationsItem-form .ant-select {\n  width: 100%;\n}\n\n.CertificationsItem-form .CertificationsItem-date {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.CertificationsItem-form {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  grid-template-rows: auto;\n  gap: 8px 8px;\n  grid-auto-flow: row;\n  grid-template-areas:\n    \"a b\";\n  padding-top: 16px;\n}\n\n.cloud-success-message {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 6px;\n\n  background: #D8EBFD;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  color: #063E75;\n  margin-bottom: 15px;\n  border-radius: 6px;\n}\n\n.a {\n  grid-area: a;\n}\n\n.b {\n  grid-area: b;\n}\n\n.ongoing_project {\n  grid-area: ongoing_project;\n  padding-top: 10px;\n}\n\n\n.WorkHistoryItemProjectItem-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-template-rows: auto auto auto auto auto auto auto auto;\n  gap: 8px 8px;\n  grid-auto-flow: row;\n  grid-template-areas:\n    \"listErrors listErrors listErrors listErrors\"\n    \"tt tt tt tt\"\n    \"a a b b\"\n    \"c d e f\"\n    \"ongoing_project ongoing_project ongoing_project ongoing_project\"\n    \"g g g g\"\n    \"outcome outcome outcome outcome\"\n    \"h h h h\"\n    \"i i i i\"\n  ;\n  padding-top: 16px;\n}\n\n.outcome {\n  grid-area: outcome;\n}\n\n.tt {\n  grid-area: tt;\n  color: #212121;\n  font-size: 14px;\n  line-height: 21px;\n  margin: 10px 0;\n  font-weight: 500;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.WorkHistoryItemProjectItem-form .g textarea, .WorkHistoryItem-form .h textarea {\n  min-height: 155px;\n}\n\n.WorkHistoryItemProjectItem-title,\n.WorkHistoryItemProjectItem-title2,\n.WorkHistoryItemProjectItem-title3 {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.addNewProjectItem {\n  margin: 2px 0 !important;\n  font-weight: 500;\n}\n\n.WorkHistoryItemProjects-titles {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.WorkHistoryItemProjects-title {\n  color: #212121;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 500;\n}\n\n.WorkHistoryItemProjects-title span {\n  margin-right: 10px;\n}\n\n.FinalizeResumeV2RequiredActionsparent .ant-collapse-item {\n  background-color: #fff !important;\n}\n\n.AdditionalInformationForm-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #212121;\n  font-size: 20px;\n  line-height: 26px;\n  font-weight: 500;\n}\n\n.FinalizeResumeV2 .ant-form-item-label,\n.FinalizeResumeV2 .ant-collapse-content {\n  overflow: visible;\n}\n\n.TuringCollapse-warning {\n  padding: 5px;\n  background-color: #FFCF3F;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  margin: -2px 0;\n}\n\n.TuringCollapse-warning>span {\n  color: #fff !important;\n  font-size: 20px !important;\n  line-height: 20px !important;\n}\n\n/* .FinalizeResumeV2RequiredActions .ant-collapse-item {\n  max-height: 85vh;\n  overflow-y: auto;\n} */\n\n.FinalizeResumeV2RequiredActions .ant-collapse-item::-webkit-scrollbar,\n.FinalizeResumeV2RequiredActions::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n.FinalizeResumeV2RequiredActions .ant-collapse-item::-webkit-scrollbar-thumb,\n.FinalizeResumeV2RequiredActions::-webkit-scrollbar-thumb {\n  background: #B3AFB3;\n  border-radius: 5px;\n}\n\n.FinalizeResumeV2RequiredActions .ant-collapse-item::-webkit-scrollbar-thumb:hover,\n.FinalizeResumeV2RequiredActions::-webkit-scrollbar-thumb:hover {\n  background: #666666;\n}\n\n.FinalizeResumeV2RequiredActions .ant-collapse-item::-webkit-scrollbar-track,\n.FinalizeResumeV2RequiredActions::-webkit-scrollbar-track {\n  background: #F0F0F0;\n  border-radius: 4px;\n  box-shadow: inset 0px 0px 0px 0px #F0F0F0;\n}\n\n.show-placeholder .ant-select-selection__placeholder {\n  display: block !important;\n}\n\n.FinalizeResumeV2Sep {\n  height: 30px;\n}\n\n.FinalizeResumeV2 .ant-steps {\n  padding-left: 8px;\n}\n\n.addNewProjectItemcontainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.addNewProjectItemcontainer button {\n  font-size: 12px;\n  height: 27px;\n  line-height: 15px;\n}\n\n.btnnotenoughexp {\n  white-space: pre-wrap;\n  margin-bottom: 15px;\n  display: block;\n  height: fit-content;\n  padding: 10px;\n}\n\n.screenshots-error b, .profile-error {\n  color: red;\n}\n\n.screenshots-error .ant-upload.ant-upload-select-picture-card {\n  border-color: red;\n}\n\n.openStep>.ant-steps-item-container>.ant-steps-item-icon>.ant-steps-icon>.ant-steps-icon-dot {\n  background-color: #000;\n  border: 4px solid rgba(255, 255, 255, 0.7);\n  width: 20px;\n  height: 20px;\n  margin-left: -6px;\n  margin-top: -2px;\n}\n\n.step-custom-fill svg path {\n  fill: #212121;\n}\n\n.TuringStepsFormv2 .ant-steps-item-content {\n  padding-top: 2px;\n}\n\n.TuringStepsFormv2 .openStep>.ant-steps-item-content {\n  padding-top: 5px;\n}\n\n.WorkHistoryItemProjects .ant-steps-item-title {\n  margin-top: -8px;\n}\n\n.WorkHistoryItemProjects .openStep .ant-steps-item-title {\n  margin-top: -10px;\n}\n\n.ant-steps-icon-dot {\n  -webkit-transition: none !important;\n  -moz-transition: none !important;\n  -o-transition: none !important;\n  transition: none !important;\n}\n\n.WorkHistoryItemProjects .ant-steps-item-container>.ant-steps-item-icon>.ant-steps-icon>.ant-steps-icon-dot {\n  background-color: #fff;\n  border: 3px solid #000;\n  width: 12px;\n  height: 12px;\n  margin-left: -2px;\n  margin-top: 2px;\n}\n\n.WorkHistoryItemProjects .openStep .ant-steps-item-container>.ant-steps-item-icon>.ant-steps-icon>.ant-steps-icon-dot {\n  background-color: #000;\n  border: 3px solid rgba(255, 255, 255, 0.7);\n  width: 12px;\n  height: 12px;\n  margin-left: -2px;\n}\n\n.WorkHistoryItemProjectItem-title, .WorkHistoryItemProjectItem-title2 {\n  border-bottom: 1px solid #EEEEEE;\n}\n\n.WorkHistoryItemProjects .ant-steps-vertical .ant-steps-item-content {\n  min-height: 40px;\n}\n\n.WorkHistoryItemProjects .WorkHistoryItemProjectsaddnew .ant-steps-item-title {\n  margin-top: 0;\n}\n\n.WorkHistoryItemProjectsaddnew.ant-steps-item-wait .ant-steps-icon-dot {\n  border-color: #cccccc !important;\n}\n\n.SkillsSelector li.ant-select-selection__choice {\n  margin-bottom: 20px;\n  overflow: visible;\n  min-width: 109px;\n  border-radius: 12px;\n  font-size: 12px;\n  padding-left: 0;\n}\n\n.SkillsSelector-note {\n  position: absolute;\n  left: 0;\n  top: 22px;\n  font-size: 10px;\n  padding-left: 5px;\n}\n\n.SkillsSelector-Notmentioned {\n  color: #F86567;\n}\n\n.SkillsSelector li.ant-select-selection__choice .ant-select-selection__choice__remove {\n  background: #d2d2d2;\n  width: 20px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  margin-right: -3px;\n}\n\n.RequiredActionItem-close {\n  transform: scaleY(0);\n  height: 0;\n}\n\n.RequiredActionItem-open {\n  transform: scaleY(1);\n  height: auto;\n}\n\n.RequiredActionItem-btn>.material-icons {\n  color: #888888;\n}\n\n.requiredActionsListnoicon .RequiredActionItem {\n  border-top: 1px solid #ddd;\n}\n\n.requiredActionsListnoicon .RequiredActionItem:last-child {\n  border-bottom: 1px solid #ddd;\n}\n\n.requiredActionsListnoicon .RequiredActionItem:first-child {\n  border-top: 1px solid transparent;\n}\n\n.requiredActionsListnoicon .RequiredActionItemflex1 {\n  padding-left: 16px;\n  margin: 10px 0;\n}\n\n.requiredActionsListnoicon .RequiredActionItem {\n  margin-bottom: 0;\n}\n\n.requiredActionsListnoicon .ant-collapse-content-active {\n  margin-left: -7px;\n}\n\n.requiredActionsListnoicon .ant-collapse-item-active {\n  overflow: visible;\n}\n\n.skillMentionsItem {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.skillMentionsItem-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.skillMentionsItem-editlink {\n  font-weight: 500;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.focusAnimation {\n  border: 2px solid #ffcf3f !important;\n  position: relative;\n}\n\n.roleatthecompany {\n  margin: -20px 0 20px 0;\n}\n\n.roleatthecompany textarea {\n  min-height: 155px;\n}\n\n.Delete-work-experience-item-p {\n  margin-top: 20px;\n}\n\n.Delete-work-experience-item>h1 {\n  color: #F86567;\n  font-size: 20px;\n  line-height: 32px;\n}\n\n.Delete-work-experience-item-details {\n  padding: 5px 10px;\n  border-left: 5px solid #F86567;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  font-size: 14px;\n  line-height: 19px;\n}\n\n.Delete-work-experience-item-details>span>*+* {\n  margin-left: 5px;\n}\n\n.delete-item-modal {\n  top: 50% !important;\n  margin-top: -117px !important;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.color-aaa {\n  color: #AAAAAA;\n}\n\n/* Peter Adeoye: New Resume Parser Improvement CSS */\n\n.upload-new-resume .ant-card-body {\n  padding: 18px !important;\n  font-size: 14px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.upload-new-resume span {\n  margin-left: 12px;\n}\n\n.upload-new-resume a {\n  font-weight: 500;\n  color: #2E6EDF !important;\n}\n\n.upload-resume-warning-modal .ant-modal-close-x {\n  display: none\n}\n\n.upload-resume-warning-card {\n  margin-bottom: 8px;\n  cursor: pointer;\n  border: 1px solid #DDDDDD;\n  border-radius: 6px;\n}\n.upload-resume-warning-card .ant-card-body {\n  padding: 16px !important;\n}\n\n.resume-upload-warning-title {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 150%;\n  color: #212121;\n  margin-bottom: 16px;\n}\n\n.upload-resume-warning-modal .upload-resume-cancel-btn {\n  color: #666666;\n  margin-top: 16px;\n}\n\n.upload-resume-warning-modal .ant-modal-content {\n  background: #FFFFFF;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n}\n\n.upload-resume-warning-card__title {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 160%;\n  color: #000000;\n}\n\n.upload-resume-max-size {\n  margin-top: 8px;\n  color: #888888;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n}\n\n.upload-resume__title {\n  font-weight: 500;\n  font-size: 17px;\n  line-height: 23px;\n  letter-spacing: 0.15px;\n  color: #212121;\n  margin-bottom: 16px;\n}\n\n.resume-upload-dragger-text {\n  margin-left: 16px;\n  text-align: left;\n  color: #2E6EDF;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n  cursor: pointer;\n}\n\n.resume-upload-dragger-text__bigtext {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.resume-upload-dragger-text__smalltext {\n  font-size: 14px;\n}\n\n.upload-btn-row .ant-btn-primary {\n  background: #2E6EDF;\n  border-radius: 6px;\n}\n\n.resume-upload-dragger .ant-upload-drag {\n  width: 546px;\n  height: 140px;\n}\n\n.replace-selected-resume svg {\n  width: 20px !important;\n  height: 13.33px !important;\n}\n\n.selected-resume-row {\n  margin-left: 16px;\n  margin-right: 16px;\n  width: 500px;\n}\n\n.resume-upload-dragger .ant-upload-list {\n  display: none;\n}\n\n.selected-resume-file {\n  display: flex;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 140%;\n  letter-spacing: 0.25px;\n  color: #888888;\n  width: 70%;\n  text-align: left;\n  align-items: center;\n}\n\n.replace-selected-resume .ant-btn {\n  color: #2E6EDF !important;\n}\n\n.selected-resume-file span {\n  margin-left: 11.33px;\n  width: 90%;\n}\n\n.delete-existing-info-warning__header {\n  margin-bottom: 8px;\n}\n\n.delete-existing-info-warning__header svg {\n  width: 19.06px !important;\n  height: 17.01px !important;\n}\n\n.delete-existing-info-warning__header span {\n  margin-left: 10.47px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 27px;\n  color: #F86567;\n}\n\n.delete-existing-info-warning__text {\n  margin-bottom: 24px;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: #212121;\n}\n\n.delete-existing-info-warning__buttons {\n  margin-bottom: -8px !important;\n}\n\n.delete-existing-info-warning__buttons .ant-btn {\n  height: 40px !important\n}\n\n.delete-existing-info-warning__buttons .ant-btn-danger {\n  width: 170px !important\n}\n\n.resume-uploaded-alert .ant-alert {\n  min-height: 58px !important;\n  height: auto;\n}\n\n.resume-uploaded-alert .ant-alert-success {\n  background: #E0F5E6;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\n  border-radius: 8px;\n}\n\n.resume-uploaded-alert .ant-icon-close {\n  color: #C4C4C4 !important;\n}\n\n.resume-uploaded-alert svg {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n.resume-uploaded-alert .ant-alert-description {\n  font-size: 14px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n  color: #1F5C2E;\n}\n\n.resume-uploaded-alert .anticon-check-circle > svg {\n  width: 20px !important;\n  height: 20px !important;\n  color: #1F5C2E;\n}\n.resume-warning-alert.ant-alert {\n  height: fit-content;\n  margin: auto;\n  background: #FFE6E6;\n  border-color: #FFE6E6;\n  border-radius: 6px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.resume-warning-alert svg {\n  width: 15.89px;\n  height: 14.17px;\n}\n\n.resume-warning-alert .anticon {\n  margin-top: -4px;\n}\n\n.resume-warning-alert .ant-alert-message {\n  font-size: 14px;\n  line-height: 20px;\n  color: #750507;\n}\n\n.resume-warning-alert > .anticon > svg > g > path {\n  fill: #750507 !important\n}\n\n.custom-edit {\n  color: #2E6EDF !important;\n}\n\n.preview-resume-btn {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px 10px 12px;\n}\n\n.view-uploaded-resume-btn {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px 10px 12px;\n}\n\n.view-uploaded-resume-btn:hover {\n  border: 1px solid #2E6EDF;\n  background: #fff;\n}\n\n.custom-warning-align {\n  flex: 1;\n  text-align: right;\n}\n.see-more-0r-less{\n  color: #2E6EDF;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.resume-text {\n  font-weight: 100;\n  color: #444;\n}\n\n.parsedInfo.TuringCollapse .ant-collapse-content-box {\n  padding: 14px 16px 22px 16px !important;\n}\n\n.parsedInfo.requiredActionsListnoicon .RequiredActionItemflex1 {\n  padding: 0;\n  margin: 16px 0;\n}\n\n.parsedInfo .view-uploaded-resume-btn {\n  margin-right: 0;\n  margin-bottom: 14px;\n}\n\n.parsedInfo .parsedInfo-text .text {\n  margin-bottom: 0;\n}\n\n.requiredActionsListnoicon.hide {\n  display: none;\n}\n\n.WorkHistoryItem-form .anticon-close-circle {\n  display: none;\n}\n\n.WorkHistory-flex {\n  display: flex;\n  cursor: pointer;\n}\n\n.WorkHistory-flex .resume-warning-alert,\n.WorkHistoryItem-title2 .resume-warning-alert,\n.WorkHistoryProject-flex .resume-warning-alert{\n  font-weight: normal;\n}\n\n.WorkHistoryProject-flex{\n  margin-top: 7px;\n  display: flex;\n  cursor: pointer;\n}\n\n.tiny-margin-left {\n  margin-left: 10px;\n  top: 3px;\n}\n.ProjectName-flex {\n  display: flex;\n}\n\n.deleteAndIcon {\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-self: center;\n  justify-content: space-between;\n  margin-left: 10px;\n}\n\n.WorkHistoryItem-missing-information-left-margin,\n.WorkHistoryItem-missing-information-left-margin2,\n.WorkHistoryItem-missing-information-left-margin3{\n  margin-left: 10px;\n  align-self: center;\n}\n\n\n.deleteIconMarginLeft {\n  margin-right: 10px;\n}\n\n.openClose {\n  color: #ccc;\n}\n\n.projectTitle-open {\n  margin-bottom: 5px;\n}\n\n\n\n@media screen and (max-width: 1220px) {\n  .WorkHistoryItem-title3 {\n    margin-top: 5px;\n    margin-bottom: 10px;\n  }\n\n  .WorkHistory-flex .WorkHistoryItem-missing-information-left-margin3 {\n    position: absolute;\n    left: 0;\n    bottom: -20px;\n    margin-left: 0px;\n    width: 200px;\n  }\n}\n\n@media screen and (max-width: 1370px) {\n  .WorkHistoryProject-flex .WorkHistoryItem-missing-information-left-margin3 {\n    position: absolute;\n    left: 0;\n    bottom: -20px;\n    margin-left: 0px;\n    width: 200px;\n  }\n}\n\n@media screen and (max-width: 1500px) {\n  .WorkHistory-flex, .WorkHistoryProject-flex{\n    position: relative;\n    margin-bottom: 20px;\n  }\n\n  .WorkHistoryItem-title2 {\n    margin-top: 5px;\n    margin-bottom: 10px;\n    width: 90%;\n  }\n\n  .ProjectName-flex {\n    position: relative;\n  }\n\n  .WorkHistory-flex .WorkHistoryItem-missing-information-left-margin {\n    position: absolute;\n    left: 0;\n    bottom: -20px;\n    margin-left: 0px;\n    width: 200px;\n  }\n\n  .WorkHistoryProject-flex .WorkHistoryItem-missing-information-left-margin {\n    position: absolute;\n    left: 0;\n    bottom: -22px;\n    margin-left: 0px;\n    width: 200px;\n  }\n\n  .WorkHistoryItemProjectItem-title2, .WorkHistoryItemProjectItem-title3{\n    width: 80%;\n  }\n}\n\n@media screen and (min-width: 1501px) {\n  .WorkHistoryItemProjectItem-title3 {\n    width: 50%;\n  }\n\n  .WorkHistoryItemProjectItem-title2 {\n    width: 50%;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
